import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";
import api, { formatApiError } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset successfully. Please sign in.");
      navigate("/login");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-nx flex min-h-[80vh] items-center justify-center py-12">
      <div className="w-full max-w-md">
        <div className="card-nx p-8 animate-fade-up">
          <div className="flex justify-center"><Logo /></div>
          <h1 className="mt-6 text-center text-2xl font-bold text-[#0B192C] font-head">Set a new password</h1>
          {!token ? (
            <p className="mt-4 text-center text-sm text-red-600" data-testid="reset-no-token">
              This reset link is invalid. Please request a new one.
            </p>
          ) : (
            <form onSubmit={submit} className="mt-7 space-y-4" data-testid="reset-form">
              <div>
                <label className="mb-1.5 block text-sm font-medium text-[#0B192C]">New password</label>
                <input type="password" required minLength={6} value={password}
                  onChange={(e) => setPassword(e.target.value)} className="input-nx"
                  placeholder="At least 6 characters" data-testid="reset-password-input" />
              </div>
              <div>
                <label className="mb-1.5 block text-sm font-medium text-[#0B192C]">Confirm password</label>
                <input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)}
                  className="input-nx" placeholder="Re-enter password" data-testid="reset-confirm-input" />
              </div>
              {error && <p className="text-sm text-red-600" data-testid="reset-error">{error}</p>}
              <button type="submit" disabled={loading} className="btn-gold w-full" data-testid="reset-submit-btn">
                {loading ? "Resetting..." : "Reset password"}
              </button>
            </form>
          )}
          <p className="mt-6 text-center text-sm text-slate-500">
            <Link to="/login" className="font-semibold text-[#0B192C] hover:underline" data-testid="reset-login-link">
              Back to sign in
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
